import React, { useEffect, useState } from 'react';
import {
  TextField,
  CircularProgress,
  Autocomplete,
  Box,
  Avatar,
  Typography,
} from '@mui/material';
import _ from 'lodash';
import * as userApi from '../../../../lib/api/user';

const UserSelectbox = ({ formik, name, label, variant, margin, required, size }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  //const loading = open && options.length === 0;
  const loading = options.length === 0;
  const [defaultValue, setDefaultValue] = useState(null);

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      try {
        const response = await userApi.getUsers();
        if (active) {
          setOptions(response.data.list);
          
        }
      } catch (err) {
        console.log(err);
      }
    })();

    return () => {
      active = false;
    };
  }, []);
  
  useEffect(() => {
   if(options.length > 0){
    if (
      formik.values[name] !== null &&
      formik.values[name] !== '' &&
      formik.values[name] !== undefined
    ) {
      const selected = _.find(options, (option)=> option.usrUuid === formik.values[name]);
      setDefaultValue(selected)
    }
   }
  }, [formik.values, name, options]);
  


  return (
    <Autocomplete
      loading={loading}
      id={name}
      options={options}
      open={open}
      disableClearable
      freeSolo
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onInputChange={(event, newInputValue) => {
        if (newInputValue === '' || newInputValue === null) {
          formik.setFieldValue(name, '');
          setDefaultValue(newInputValue);
        }
      }}
      onChange={(event, newValue) => {
        if (newValue !== null && newValue !== undefined) {
          formik.setFieldValue(name, newValue?.usrUuid);
          setDefaultValue(newValue);
        }
      }}
      value={defaultValue || ''}
      autoHighlight
      getOptionLabel={(option) => option.usrNm ? option.usrNm : ""}
      isOptionEqualToValue={(option, value) => {
        let selectedValue = typeof value === 'string' ? value : value?.usrUuid;
        return option.usrUuid === selectedValue;
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            p: 1,
          }}
          {...props}
        >
          <Box sx={{ flexShrink: 0 }}>
            {option.profileImg ? (
              <Avatar alt={option.usrNm} src={option.profileImg} />
            ) : (
              <Avatar>{option?.usrNm.substring(0,1)}</Avatar>
            )}
          </Box>
          <Box sx={{ flexGrow: 1, ml: 2 }}>
            <Typography variant="subtitle1">{option.usrNm} {option.gradeNm}</Typography>
            <Typography variant="body2">
              {option.dptNm}
            </Typography>
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          size={size}
          required={required}
          margin={margin}
          variant={variant}
          label={label}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
          InputProps={{
            ...params.InputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default UserSelectbox;
